export default {
    "Dear user, Thank you for your interest in joining our community. Unfortunately, your location isn't supported.": "Αγαπητέ χρήστη,\n\nΣας ευχαριστούμε για το ενδιαφέρον σας να γίνετε μέλος της κοινότητάς μας. Δυστυχώς, η τοποθεσία σας δεν υποστηρίζεται.",
	"Already a member?": "Ήδη μέλος;",
	"Login": "Σύνδεση",
	"Log out": "Αποσυνδεση",
	"Your current status": "Η τρέχουσα κατάστασή σας",
	"BASIC": "ΒΑΣΙΚΟΣ",
	"Basic": "Βασικός",
	"Bronze": "Χάλκινος",
	"Elite": "Ελίτ",
	"VIP": "VIP",
	"Join Us": "Ελα μαζί μας",
	"Find people near you": "Βρείτε άτομα κοντά σας",
	"Join now": "Γίνε μέλος τώρα",
	"I am a": "Είμαι",
	"Email": "Hλεκτρονικη διευθυνση",
	"It will not be published": "Δεν θα δημοσιευθεί",
	"E-mail address": "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
	"SEARCH NOW": "ΨΑΞΕ ΤΩΡΑ",
	"I confirm that I am over 18 years old": "Επιβεβαιώνω ότι είμαι άνω των 18 ετών",
	"Do not just think about it! Discover the hottest dating site in Australia. Every day thousands of people like you join us.": "Μην το σκέφτεστε άλλο! Ανακαλύψτε τον πιο καυτό ιστότοπο γνωριμιών στην Ελλάδα. Κάθε μέρα χιλιάδες άνθρωποι σαν εσάς γίνονται μέλη μας.",
	"Information": "Πληροφορίες",
	"All rights reserved.": "Με επιφύλαξη κάθε δικαιώματος .",
	"SUBSCRIPTION": "ΣΥΝΔΡΟΜΗ",
	"Other": "Άλλα",
	"All fields are required": "Όλα τα πεδία είναι υποχρεωτικά",
	"The fields marked in Red are required. Please fill them to continue.": "Τα πεδία που σημειώνονται με κόκκινο είναι υποχρεωτικά. Συμπληρώστε τα για να συνεχίσετε.",
	"If you did not find a suitable answer please contact us": "Εάν δεν βρήκατε την κατάλληλη απάντηση, επικοινωνήστε μαζί μας",
	"Will help us to identify you": "Θα μας βοηθήσει να σας ταυτοποιήσουμε",
	"Invalid Username": "Μη έγκυρο όνομα χρήστη",
	"Subject": "Θέμα",
	"Tell us how can we help you": "Πείτε μας πώς μπορούμε να σας βοηθήσουμε",
	"Please enter subject": "Παρακαλώ εισάγετε θέμα",
	"Please enter at least 10 characters": "Εισαγάγετε τουλάχιστον 10 χαρακτήρες",
	"Connected to your account": "Συνδέθηκε στον λογαριασμό σας",
	"Repeat Email": "Επαναποστολή ηλεκτρονικού μηνύματος",
	"Emails did not match": "Τα μηνύματα ηλεκτρονικού ταχυδρομείου δεν ταίριαζαν",
	"Message": "Μήνυμα",
	"No Recent Activity": "Δεν υπάρχει πρόσφατη δραστηριότητα",

	//route labels
	"Home": "Αρχική",
	"Contact": "Επικοινωνία",
	"Support": "Υποστήριξη",
	"Affiliates": "Συνεργάτες",
	"Privacy": "Ιδιωτικότητα",
	"Terms": "Οροι",

	//routes uri
	"/login": "/syndesi",
	"/contact": "/epikinonia",
	"/support": "/ipostirixi",
	"/affiliates": "/sinergates",
	"/privacy": "/idiotikotita",
	"/terms-and-conditions": "/ori-ke-proipothesis",
	"/cookie-policy": "/cookie-policy",
	"/subscription/exit": "/sindromi/exodos",
	"/purchase-confirmation": "/agora-epivevaiosi",
	"/page/:page_name": "/selida/:page_name",

	"/dashboard": "/tablo",
	"/mobile-dashboard": "/kinito-dashboard",
	"/activate-profile/:token": "/energopiisi-profil/:token",
	"/edit-profile": "/epexergasia-profil",
	"/profile/:name": "/profil/:name",
	"/my-picture": "/i-ikona-mou",
	"/messages/inbox": "/minimata/iserxomena",
	"/messages/trash": "/minimata/kados-aporimaton",
	"/messages/send/:name": "/minimata/apostoli/:name",
	"/visitor": "/episkeptis",
	"/favorite/my": "/agapimena/mou",
	"/favorite/others": "/agapimena/alla",
	"/search": "/anazitisi",
	"/search-result": "/apotelesma-anazitisis",
	"/settings": "/rythmisis",
	"/validate-new-email-address/:token": "/epikirosi-nea-ilektroniki-diefthinsi/:token",
	"/subscription": "/syndromi",
	"/credits": "/monades",
	"/elite": "/elit",
	"/premium": "/asfalistro",
	"/faq": "/sychnes-erotisis",
	"/delete-account": "/diagrafi-logariasmou",
    "/complete-register/:token" : '/complete-registration/:token',

	"/exclusive-promotion": "/apoklistiki-proothisi",
	"/account-deleted": "/logariasmos-katargisi",
	"/logged-out": "/aposyndethika",
	"/disable-notifications": "/apenergopiisi-idopiisis",

	//login
	"Login": "Σύνδεση",
	"Enter username or Email": "Εισαγάγετε όνομα χρήστη ή email",
	"Enter Password": "Εισάγετε τον κωδικό πρόσβασης",
	"Username": "Όνομα χρήστη",
	"Nickname": "Nickname",
	"Password": "Κωδικός πρόσβασης",
	"I forgot my password": "Ξέχασα τον κωδικό μου",
	"Password Reminder": "Υπενθύμιση κωδικού",
	"Enter you email": "Εισαγάγετε το email σας",
	"Your email address": "η ηλεκτρονική σου διεύθυνση",
	"Don't have an account?": "Δεν έχετε λογαριασμό;",
	"REGISTER": "ΚΑΝΩ ΕΓΓΡΑΦΗ",
	"Password sent to your email": "Ο κωδικός πρόσβασης στάλθηκε στο email σας",
	"This account has not been validated yet": "Αυτός ο λογαριασμός δεν έχει επικυρωθεί ακόμα",
	"LOGIN USING YOUR CREDENTIALS": "ΕΙΣΟΔΟΣ ΧΡΗΣΙΜΟΠΟΙΩΝΤΑΣ ΤΑ ΔΙΑΠΙΣΤΕΥΤΗΡΙΑ ΣΑΣ",
	"FORGOT YOUR PASSWORD?": "ΞΕΧΑΣΑΤΕ ΤΟΝ ΚΩΔΙΚΟ ΣΑΣ;",
	"Login failed": "Η σύνδεση απέτυχε",
	"Username or password is incorrect": "Ονομα χρήστη ή κωδικός πρόσβασης είναι εσφαλμένος",

	"We're sorry!": "Λυπόμαστε!",
	//registration
	"You're almost done!": "Εχεις σχεδόν τελειώσει!",
	"Please fill your additional account information": "Συμπληρώστε τα πρόσθετα στοιχεία του λογαριασμού σας",
	"Just one step left!": "Μόλις ένα βήμα έμεινε!",
	"Let us learn more about you. Fill in your personal data": "Αφήστε μας να μάθουμε περισσότερα για εσάς. Συμπληρώστε τα προσωπικά σας δεδομένα",
	"Activate your account now.": "Ενεργοποιήστε τον λογαριασμό σας τώρα.",
	"Activate your account now": "Ενεργοποιήστε τον λογαριασμό σας τώρα",
	"Please confirm your e-mail address": "Παρακαλούμε να επιβεβαιώσετε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας",
	"Please fill in the following form to join {site_name} for free": "Συμπληρώστε την παρακάτω φόρμα για να εγγραφείτε δωρεάν στο {site_name}",
	"CONTINUE": "ΣΥΝΕΧΕΙΑ",

	"By clicking on the continue button I agree with the": "Κάνοντας κλικ στο \"ΣΥΝΕΧΕΙΑ\" συμφωνώ με τους",
	"terms": "όρους",
	"and cookies": "και cookies",

	"This site is protected by reCaptcha and the Google": "Αυτός ο ιστότοπος προστατεύεται από το reCaptcha και την Google",
	"Privacy Policy": "Πολιτική Απορρήτου",
	"and": "και",
	"Terms of Service": "Όροι χρήσης",
	"apply.": "αίτηση.",

	"Personal description": "Προσωπική περιγραφή",
	"optional": "προαιρετικό",
	"FINALIZE": "ΟΡΙΣΤΙΚΟΠΟΙΩ",
	"We have just sent you a confirmation e-mail at": "Μόλις σας στείλαμε ένα e-mail επιβεβαίωσης στη διεύθυνση",
	"To start using our website, please click on the activation link in this email.": "Για να ξεκινήσετε να χρησιμοποιείτε τον ιστότοπό μας, κάντε κλικ στον σύνδεσμο ενεργοποίησης σε αυτό το email.",
	"Click here to verify your email": "Κάντε κλικ εδώ για να επαληθεύσετε το email σας",
	"CLICK TO ACTIVATE": "ΚΑΝΤΕ ΚΛΙΚ ΓΙΑ ΕΝΕΡΓΟΠΟΙΗΣΗ",
	"CLICK TO ACTIVATE - desktop": "ΚΑΝΤΕ ΚΛΙΚ ΓΙΑ ΕΝΕΡΓΟΠΟΙΗΣΗ",
	"VERIFY MY EMAIL": "ΕΠΑΛΗΘΕΥΣΗ ΤΟΥ EMAIL ΜΟΥ",
	"Not received any email yet?": "Δεν έχετε λάβει κάποιο email ακόμα;",
	"Please check your": "Παρακαλώ ελέγξτε το",
	"spam": "ανεπιθυμητη αλληλογραφια",
	"box and wait at least 10 minutes or re-send activation": "και περιμένετε τουλάχιστον 10 λεπτά ή στείλτε ξανά την ενεργοποίηση",
	"Enter Nickname": "Εισαγάγετε ψευδώνυμο",
	"Enter Your Name": "Εισάγετε το όνομά σας",
	"Password Required": "Απαιτείται κωδικός πρόσβασης",
	"Enter valid Email": "Εισαγάγετε έγκυρο email",
	"Please enter at least 5 characters": "Εισαγάγετε τουλάχιστον 5 χαρακτήρες",
	"Enter strong password": "Εισαγάγετε ισχυρό κωδικό πρόσβασης",
	"Email not available": "Το email δεν είναι διαθέσιμο",
	"Nickname not available": "Ψευδώνυμο δεν είναι διαθέσιμο",
	"Maximum 4 number allowed": "Επιτρέπονται έως 4 αριθμοί",
	"Name should not contain any space, number or special character": "Το όνομα δεν πρέπει να περιέχει κανένα κενό, αριθμό ή ειδικό χαρακτήρα",
	"Nickname should not contain any space or special characters": "Το ψευδώνυμο δεν πρέπει να περιέχει κανένα κενό διάστημα ή ειδικούς χαρακτήρες",
	"Your activation mail has been sent": "Το email ενεργοποίησής σας έχει σταλεί",
	"Complete your profile in a minute and start contacting people": "Ολοκληρώστε το προφίλ σας σε ένα λεπτό και αρχίστε να επικοινωνείτε με άτομα",
	"Complete your profile": "Συμπληρώστε το προφίλ σας",
	"Create Profile": "Δημιουργία Προφίλ",
	"Your description": "Η περιγραφή σου",
	"Confirm your Email": "Επιβεβαιώστε το email σας",
	"We have sent you an email.": "Σας έχουμε στείλει ένα email.",
	"Check your email to complete your registration": "Ελέγξτε το email σας για να ολοκληρώσετε την εγγραφή σας",
	"and be able to speak with other users.": "και να μπορείτε να μιλήσετε με άλλους χρήστες.",
	"If you can not find it look it up in the spam or": "Εάν δεν μπορείτε να το βρείτε, αναζητήστε το στα spam ή",
	"If you have not received it select one of the following options": "Εάν δεν το έχετε λάβει, επιλέξτε μία από τις παρακάτω επιλογές",
	"junk folder": "άχρηστος φάκελος",
	"Change Email": "Αλλαγή email",
	"Resend Email": "Επαναποστολή ηλεκτρονικού μηνύματος",
	"Resend": "Εκ νέου αποστολή",
	"New Email": "Νέο Ηλεκτρονικό Μήνυμα",
	"Your activation key is invalid": "Το κλειδί ενεργοποίησής σας δεν είναι έγκυρο",
	"Please include an '@' in the email address. '{email}' doesn't have an '@'": "Συμπεριλάβετε ένα '@' στη διεύθυνση email. Το '{email}' δεν έχει '@'",

	//public pages
	"privacy": "idiotikotita",
	"terms-and-conditions": "ori-ke-proipothesis",
	"about-us": "sxetika-memas",

	//forms
	"Name": "Όνομα",
	"Marital Status": "Στάτους",
	"Date of Birth": "Ημερομηνία γέννησης",
	"Country": "Χώρα",
	"Location": "Τοποθεσία",
	"Province": "Επαρχία",
	"City": "Πόλη",
	"Save Changes": "Αποθήκευση αλλαγών",
	"Select from list": "Επιλογή από την λίστα",
	"Day": "Ημέρα",
	"Month": "Μήνας",
	"month": "μήνας",
	"Year": "Ετος",
	"Prefer not to say": "Καμία επιλογή",
	"Only profiles with photo": "Μόνο προφίλ με φωτογραφία",
	"This field is required": "Αυτό το πεδίο είναι υποχρεωτικό",
	"Please update your profile": "Ενημερώστε το προφίλ σας",
	"Profile successfully updated": "Το προφίλ ενημερώθηκε με επιτυχία",
	"The fields marked in red are required. Please fill them to continue.": "Τα πεδία που σημειώνονται με κόκκινο είναι υποχρεωτικά. Παρακαλούμε συμπληρώστε τα για να συνεχίσετε.",
	"Characters left": "Εναπομείναντες χαρακτήρες",
	"Image attached": "Επισυνάπτεται εικόνα",
	"The message field is required.": "Το πεδίο μηνύματος είναι υποχρεωτικό.",
	"WITH PICTURE": "ΜΕ ΕΙΚΟΝΑ",
	"all age groups": "όλες οι ηλικιακές ομάδες",
	"EDIT DESCRIPTION": "ΕΠΕΞΕΡΓΑΣΙΑ ΠΕΡΙΓΡΑΦΗΣ",
	"DESCRIPTION": "ΠΕΡΙΓΡΑΦΗ",
	"FEATURING": "ΧΑΡΑΚΤΗΡΙΣΤΙΚΑ",
	"Please Select": "Παρακαλώ επιλέξτε",
	"Emails do not match": "Τα email δεν ταιριάζουν",
	"Your request was succesfully sent!": "Το αίτημά σας στάλθηκε με επιτυχία!",
	"Or send us a message directly": "Ή στείλτε μας ένα μήνυμα απευθείας",

	//user pages
	"My Profile": "Προφίλ",
	"Add Photos": "Βάλε φωτογραφίες",
	"Messages": "Μηνύματα",
	"Favorites": "Αγαπημένα",
	"Search": "Αναζητηση",
	"Settings": "Ρυθμίσεις",
	"Visits": "Επισκέψεις",
	"Likes": "Likes",
	"Membership": "Κατάσταση",
	"Vip Members": "Vip μέλη",
	"Profile_mobile_menu": "Προφίλ",

	"Account activation successful": "Επιτυχής ενεργοποίηση λογαριασμού",
	"My chats": "Οι συνομιλίες μου",

	//user home
	"Quick Search": "Γρήγορη αναζήτηση",
	"More Options": "Περισσοτερες επιλογες",
	"I am a": "Είμαι",
	"Looking for": "Ψάχνω",
	"Age": "Ηλικία",
	"Search for": "Ψάχνω για",
	"All age groups": "Όλες οι ηλικιακές ομάδες",
	"Popular Members": "Δημοφιλή Μέλη",
	"New Members": "Νέα μέλη",
	"Find a Match": "Βρείτε ένα ταίρι",
	"Recent Activity": "Πρόσφατη Δραστηριότητα",
	"Add Photo": "Προσθήκη φωτογραφίας",
	"Back": "Πίσω",
	"Become Elite": "Γίνε Ελίτ",
	"Upgrade": "Αναβαθμίζω",

	"likes": "likes",
	"EDIT MY PROFILE": "ΕΠΕΞΕΡΓΑΣΙΑ ΤΟΥ ΠΡΟΦΙΛ ΜΟΥ",
	"CONFIGURATION": "ΔΙΑΜΟΡΦΩΣΗ",
	"ONLINE SUPPORT": "ΔΙΑΔΙΚΤΥΑΚΗ ΥΠΟΣΤΗΡΙΞΗ",

	//user message
	"Trash": "Σκουπίδια",
	"Delete Selected": "Διαγραφή επιλεγμένων",
	"No Messages Available": "Δεν υπάρχουν διαθέσιμα μηνύματα",
	"No Messages selected": "Δεν επιλέχθηκαν μηνύματα",
	"Back to inbox": "Επιστροφή στα εισερχόμενα",
	"Back to messages": "Επιστροφή στα μηνύματα",
	"Select all": "Επιλογή όλων",
	"Deselect all": "Αποεπιλογή όλων",
	"Next Page": "Επόμενη σελίδα",
	"Prev Page": "Προηγούμενη Σελίδα",
	"Type your message here": "Πληκτρολογήστε το μήνυμά σας εδώ",
	"Send message": "Στείλτε μήνυμα",
	"Send Icebreaker": "Αποστολή Icebreaker",
	"VIEW PROFILE": "ΕΜΦΑΝΙΣΗ ΠΡΟΦΙΛ",
	"DELETE": "ΔΙΑΓΡΑΦΗ",
	"Chat with": "Συζήτηση με",
	"Chat": "Συζήτηση",

	//user favorites
	"My Favorites": "Τα αγαπημένα μου",
	"No likes": "Δεν υπάρχουν Likes",
	"Favorite added successfully": "Το αγαπημένο προστέθηκε με επιτυχία",
	"Favorite deleted successfully": "Το αγαπημένο καταργήθηκε με επιτυχία",
	"Visit Profile": "Επισκεφτείτε το Προφίλ",

	//user visits
	"My Profile Visitors": "Οι επισκέπτες του προφίλ μου",
	"No Visitors": "Χωρίς Επισκέπτες",

	//user photos
	"My pictures": "Οι εικόνες μου",
	"See my public profile": "Δείτε το δημόσιο προφίλ μου",
	"Profile photo": "Η φωτογραφία προφίλ",
	"Profile Picture": "Εικόνα προφίλ",
	"2MB or lower.": "2 MB ή μικρότερη.",
	"2MB or lower": "2 MB ή μικρότερη",
	"Nudes not allowed in this category.": "Τα γυμνά δεν επιτρέπονται σε αυτή την κατηγορία.",
	"PHOTO ALBUM": "ΑΛΜΠΟΥΜ ΦΩΤΟΓΡΑΦΙΩΝ",
	"Allowed images 2 megabytes or less": "Επιτρεπόμενες εικόνες 2 megabytes ή λιγότερο",
	"Add picture": "Προσθήκη εικόνας",
	"Main reasons for rejection": "Κyριοι λoγοι απoρριψης",
	"Are you sure?": "Είσαι σίγουρος?",
	"Are you sure you want to delete this image?": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτήν την εικόνα;",
	"Close": "Κλείσε",
	"Confirm": "Επιβεβαίωση",
	"Attaching image": "Επισύναψη εικόνας",
	"The message must be at least 2 characters.": "Το μήνυμα πρέπει να αποτελείται από τουλάχιστον 2 χαρακτήρες.",
	"Deleting...": "Διαγραφή...",
	"Pictures of underage people": "Φωτογραφίες ανηλίκων",
	"Personal data is visible": "Ορατά προσωπικά δεδομένα",
	"Fake or stolen pictures": "Ψεύτικες ή κλεμμένες φωτογραφίες",
	"Different gender to profile": "Διαφορετικό φύλλο σε προφίλ",
	"Group pictures": "Ομαδικές φωτογραφίες",
	"Weapons, drugs, violence": "Όπλα, ναρκωτικά, βία",
	"No people visible": "Δεν είναι ορατά τα πρόσωπα",
	"Info": "Πληροφορίες",
	"We are reviewing your images. When they pass the verification process they will be shown to the other users.": "Εξετάζουμε τις εικόνες σας. Όταν περάσουν τη διαδικασία επαλήθευσης θα εμφανιστούν στους άλλους χρήστες.",

	//user profiles
	"Profile": "Προφίλ",
	"yrs": "χρονών",
	"years": "χρονών",
	"yr from": "έτος από",
	"Physique": "Σωματική διάπλαση",
	"Photos": "Φωτογραφίες",
	"No Photos": "Χωρίς φωτογραφίες",
	"About Me": "Σχετικά με μένα",
	"Characteristics": "Χαρακτηριστικά",
	"Prefers": "Προτιμήσεις",
	"Relationship": "Σχέση",
	"Shape": "Σχήμα",

	//user edit profile
	"DESCRIBE YOURSELF": "ΠΕΡΙΈΓΡΑΨΕ ΤΟΝ ΕΑΥΤΌ ΣΟΥ",
	"GENERAL": "ΓΕΝΙΚΆ",
	"(Will be verified)": "(Θα επαληθευτούν)",
	"Sex": "Φύλο",
	"Seeking": "Ψάχνοντας",
	"Finish your profile": "Ολοκληρώστε το προφίλ σας",
	"Welcome! As your profile is new, we will give maximum visibility once you complete it.": "Καλως ΗΡΘΑΤΕ! Καθώς το προφίλ σας είναι νέο, θα δώσουμε τη μέγιστη προβολή μόλις το ολοκληρώσετε.",

	//search profile
	"Advanced Search": "Αναζήτηση",
	"OPEN TO": "ΑΝΟΙΧΤΌΣ ΣΕ",
	"PREFERENCES": "ΠΡΟΤΙΜΉΣΕΙΣ",
	"CHARACTER": "ΧΑΡΑΚΤΉΡΑΣ",
	"Search Result": "Αποτέλεσμα αναζήτησης",
	"No Member found": "Δεν βρέθηκε μέλος",
	"Change Search": "Αλλαγή αναζήτησης",
	"Hair Color": "Χρώμα μαλλιών",
	"Eye Color": "Το χρώμα των ματιών",
	"Body Type": "Σωματότυπος",
	"Height": "Υψος",
	"Weight": "Βάρος",
	"Smoker": "Καπνιστής",
	"Ethnicity": "Εθνικότητα",
	"From": "Από",
	"To": "Προς",

	//settings
	"Change E-mail address": "Αλλαγή διεύθυνσης ηλεκτρονικού ταχυδρομείου",
	"Your email address has been successfully updated": "Η διεύθυνση email σας ενημερώθηκε με επιτυχία",
	"Password": "Κωδικός πρόσβασης",
	"Account Status": "Κατάσταση Λογαριασμού",
	"Cancel": "Ματαίωση",
	"Delete Account": "Διαγράφομαι",
	"Notifications": "Ειδοποιήσεις",
	"Receive all notifications individually": "Να λαμβάνω όλες τις ειδοποιήσεις μεμονωμένα",
	"Receive one daily email with all my notifications": "Να λαμβάνω ένα καθημερινό email με όλες τις ειδοποιήσεις μου",
	"Receive a weekly email with all my notifications": "Να λαμβάνω ένα εβδομαδιαίο email με όλες τις ειδοποιήσεις μου",
	"I don\'t want to receive any notifications": "Να μη λαμβάνω ειδοποιήσεις",
	"(we will send you a verification email)": "(θα σας στείλουμε ένα email επαλήθευσης)",
	"Current Password": "Τρέχων κωδικός πρόσβασης",
	"New Password": "Νέος Κωδικός",
	"Enter valid email": "Εισαγάγετε έγκυρο email",
	"Repeat New Password": "Επαναλάβετε το νέο κωδικό πρόσβασης",
	"Save Settings": "Αποθηκευση",
	"Passwords should match": "Οι κωδικοί πρόσβασης πρέπει να ταιριάζουν",
	"Password length should be minimum 5 characters": "Το μήκος του κωδικού πρόσβασης πρέπει να είναι τουλάχιστον 5 χαρακτήρες",
	"Attention: Your new email address must be verified by clicking on the link that we just sent you.": "Προσοχή: Η νέα σας διεύθυνση email πρέπει να επαληθευτεί κάνοντας κλικ στον σύνδεσμο που μόλις σας στείλαμε.",
	"I want to receive notifications by email": "Θέλω να λαμβάνω ειδοποιήσεις μέσω email",
	"Status": "Status",
	"Renewal": "Ανανέωση",
	"Auto renewal Canceled": "Η αυτόματη ανανέωση ακυρώθηκε",
	"Delete profile": "Διαγραφή προφίλ",
	"Your account has been deleted. You will be redirected.": "Ο λογαριασμός σας έχει διαγραφεί. Θα ανακατευθυνθείτε.",
	"Successfully updated": "Ενημερώθηκε με επιτυχία",
	"Current account status": "Κατάσταση τρέχοντος λογαριασμού",
	"Are you sure you want to cancel your subscription?": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε τη συνδρομή σας;",
	"Your subscription has been successfully canceled and will not be auto-renewed": "Η συνδρομή σας ακυρώθηκε με επιτυχία και δεν θα ανανεωθεί αυτόματα",
	"Due to technical reasons, cancellation of the renewal of the trial must be made after 8 hours of the acquisition. For any other subscription, the cancellation must be done at least 8 hours after acquisition and before 48 hours of its expiration.": "Για τεχνικούς λόγους, η ακύρωση της δοκιμαστικής ανανέωσης πρέπει να γίνει μετά από 8 ώρες από την απόκτηση. Για οποιαδήποτε άλλη συνδρομή, η ακύρωση πρέπει να γίνει τουλάχιστον 8 ώρες μετά την απόκτηση και πριν από 48 ώρες από τη λήξη της.",
	"Profile deleted. Redirecting...": "Το προφίλ διαγράφηκε. Ανακατεύθυνση...",
	"*Active subscriptions deleted this way will not be reimbursed": "*Οι ενεργές συνδρομές που διαγράφονται με αυτόν τον τρόπο δεν επιστρέφονται",
	"Are you sure you want to delete * your account? Your information will be permanently erased.": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Οι πληροφορίες σας θα διαγραφούν οριστικά.",
	"Settings successfully updated": "Οι ρυθμίσεις ενημερώθηκαν με επιτυχία",
	"Disable Notification": "Απενεργοποίηση ειδοποίησης",
	"The notifications have been successfully disabled.": "Οι ειδοποιήσεις απενεργοποιήθηκαν με επιτυχία.",
	"Canceled Auto-Renewal": "Ακυρώθηκε η αυτόματη ανανέωση",

	//subscription
	"Only Vip members can contact more than 5 different users per day.": "Μόνο τα μέλη Vip μπορούν να επικοινωνούν με περισσότερους από 5 διαφορετικούς χρήστες την ημέρα.",
	"Upgrade your status": "Αναβαθμίστε την κατάστασή σας",
	"Enjoy our exclusive benefits and make new contacts": "Απολαύστε τα αποκλειστικά προνόμιά μας και κάντε νέες επαφές",
	"Users Online": "Χρήστες Διαδικτυακοί",
	"Discreet Billing. {site_name} will not appear in the invoice": "Διακριτική Χρέωση. Το {site_name} δεν θα εμφανίζεται στο τιμολόγιο",
	"Month ::: Months": "Μήνας ::: Μήνες",
	"3 days trial": "3 ημέρες δοκιμή",
	"Try 3 days": "Δοκιμάστε 3 ημέρες",
	"MEMBERSHIP": "ΣΥΝΔΡΟΜΗ",
	"Select": "Επιλογή",
	"Send messages for 3 consecutive days": "Στείλτε μηνύματα για 3 συνεχόμενες ημέρες",
	"Only one trial subscription per user": "Μόνο μία δοκιμαστική συνδρομή ανά χρήστη",
	"In order to offer better service without interruptions, all plans will be auto renewed at the cost of one of the following subscriptions based on the pack chosen above.": "Για να προσφέρουμε καλύτερη εξυπηρέτηση χωρίς διακοπή, όλα τα προγράμματα θα ανανεώνονται αυτόματα με το κόστος μιας από τις ακόλουθες συνδρομές με βάση το πακέτο που επιλέχθηκε παραπάνω.",
	"for": "Για",
	"For full access to all details of events, including how to cancel it,": "Για πλήρη πρόσβαση σε όλες τις λεπτομέρειες των συμβάντων, συμπεριλαμβανομένου του τρόπου ακύρωσής τους,",
	"click here": "Κάντε κλικ ΕΔΩ",
	"for terms and conditions,": "για τους όρους και προϋποθέσεις,",
	"All profiles are reviewed and moderated by our team.": "Όλα τα προφίλ ελέγχονται και εποπτεύονται από την ομάδα μας.",
	"CURRENT PLAN": "ΤΡΕΧΟΝ ΣΧΕΔΙΟ",
	"Basic (no trial bonus) You do not have any active pack at this moment and you are a BASIC user. To increase your chances of connecting with and contacting other users, you will need to upgrade to Elite or VIP status.": "Βασικό (χωρίς δοκιμαστικό μπόνους) Δεν έχετε κανένα ενεργό πακέτο αυτήν τη στιγμή και είστε χρήστης BASIC. Για να αυξήσετε τις πιθανότητές σας να συνδεθείτε και να επικοινωνήσετε με άλλους χρήστες, θα χρειαστεί να κάνετε αναβάθμιση σε κατάσταση Elite ή VIP.",
	"MY BENEFITS": "ΤΑ ΟΦΕΛΗ ΜΟΥ",
	"{discount} cheaper": "{discount} φθηνότερα",
	"save": "εξοικονομείτε",
	"Create my profile": "Δημιουργήστε το προφίλ μου",
	"Read messages": "Διαβάστε μηνύματα",
	"Add to Favorites": "Προσθήκη στα αγαπημένα",
	"Make yourself visible to other users by adding them to favorites": "Κάντε τον εαυτό σας ορατό σε άλλους χρήστες προσθέτοντάς τους στα αγαπημένα",
	"Photo Album": "Αλμπουμ φωτογραφιών",
	"No fake pictures allowed": "Δεν επιτρέπονται ψεύτικες φωτογραφίες",
	"Album pictures": "Εικόνες άλμπουμ",
	"Show yourself and increase your possibilities": "Δείξτε τον εαυτό σας και αυξήστε τις δυνατότητές σας",
	"Detailed profile search": "Λεπτομερής αναζήτηση προφίλ",
	"Find exactly what you are looking for": "Βρείτε ακριβώς αυτό που ψάχνετε",
	"See other user's pics": "Δείτε τις φωτογραφίες άλλων χρηστών",
	"Choose your favorite": "Επιλέξτε το αγαπημένο σας",
	"Reply to and send messages": "Απαντήστε και στείλτε μηνύματα",
	"Make direct contact with up to five users per day": "Κάντε άμεση επαφή με έως και πέντε χρήστες την ημέρα",
	"Be shown first in searches": "Εμφανίζεται πρώτος στις αναζητήσεις",
	"Your profile will be featured before the rest of the users": "Το προφίλ σας θα εμφανίζεται πριν από τους υπόλοιπους χρήστες",
	"Make direct contact with unlimited users": "Κάνετε άμεση επαφή με απεριόριστους χρήστες",
	"Choose payment method": "Διαλέξτε μέθοδο πληρωμής",
	"LESS THAN": "ΛΙΓΟΤΕΡΟ ΑΠΟ",
	"PER DAY": "ΑΝΑ ΜΕΡΑ",
	"DISCRETION": "ΔΙΑΚΡΙΤΙΚΟΤΗΤΑ",
	"Our website name will not be disclosed": "Το όνομα του ιστότοπού μας δεν θα αποκαλυφθεί",
	"Our name will not be disclosed": "Το όνομά μας δεν θα αποκαλυφθεί",
	"100% Anonymous.": "100% Ανώνυμος.",
	"Choose your subscription": "Επιλέξτε τη συνδρομή σας",
	"Recommended": "Συνίσταται",
	"Most Popular": "Δημοφιλέστερος",
	"Secure payments with": "Ασφαλείς πληρωμές με",
	"Your message has NOT been sent. You need to upgrade your status in order to send messages.": "Το μήνυμά σας ΔΕΝ έχει σταλεί. Πρέπει να αναβαθμίσετε την κατάστασή σας για να στείλετε μηνύματα.",
	"Your purchase has been successful": "Η αγορά σας ήταν επιτυχής",
	"All subscriptions automatically renew to ensure optimum service. If you want to change the settings you can do it": "Όλες οι συνδρομές ανανεώνονται αυτόματα για να διασφαλιστεί η βέλτιστη εξυπηρέτηση. Εάν θέλετε να αλλάξετε τις ρυθμίσεις, μπορείτε να το κάνετε",
	"here.": "εδώ.",
	"after_here": "",

	//ad
	"Become a": "Γίνε",
	"PREMIUM MEMBER": "ΜΕΛΟΣ PREMIUM",
	"And contact": "Και επικοινώνησε",
	"more people": "με περισσότερους ανθρώπους",

	"upgrade": "αναβαθμίζω",
	"Boost": "ΑΝΑΒΑΘΜΙΣΕ",
	"boost": "ώθησε",
	"your profile": "το προφίλ σου",
	"Start chatting and meet more people": "Ξεκινήστε να συνομιλείτε και να γνωρίσετε περισσότερους ανθρώπους",
	"And get": "Και κερδισε",
	"more views": "περισσότερες προβολές",

	"Now +3 extra Credits with each purchase": "Τώρα +3 επιπλέον μονάδες με κάθε αγορά",
	"Best Seller": "Best Seller",
	"Select your Package": "Επιλέξτε το Πακέτο σας",
	"Less than {amount} per credit": "Λιγότερο από {amount} ανά μονάδα",
	"Less than": "Λιγότερο από",
	"per credit": "ανά μονάδα",
	"Free credits": "Δωρεάν μονάδες",
	"per purchase": "ανά αγορά",
	"Premium Status doesn’t allow free messages.": "Η κατάσταση Premium δεν επιτρέπει δωρεάν μηνύματα.",
	"Packages are not auto-renewable.": "Τα πακέτα δεν ανανεώνονται αυτόματα.",
	"Chat now": "Συνομιλία τώρα",
	"Get Credits": "λαβετε μοναδες",
	"Credit": "Μονάδα",
	"Credits": "Μονάδες",
	"My credits": "Οι μονάδες μου",
	"{count} Credits left": "Απομένουν {count} μονάδες",
	"Your message has not been sent, you need credits to be able to send messages.": "Το μήνυμά σας δεν έχει σταλεί, χρειάζεστε μονάδες για να μπορείτε να στείλετε μηνύματα.",
	"Icebreaker": "Icebreaker",
	"Icebreaker today": "Icebreaker σήμερα",
	"The cost for sending an Icebreaker is 2 credits. The Icebreaker can only be used to start a conversation or in response to another icebreaker.": "Το κόστος αποστολής Icebreaker είναι 2 μονάδες. Το Icebreaker μπορεί να χρησιμοποιηθεί μόνο για την έναρξη μιας συνομιλίας ή ως απάντηση σε άλλο icebreaker.",
	"With the acquisition of each package, users make a purchase of a pack of credits that can be used to send messages. The ratio of credits per message is ten to one, that means, the user needs to have at least ten credits in his account to send a message. The cost for sending an Icebreaker is 2 credits.": "Με την απόκτηση κάθε πακέτου, οι χρήστες πραγματοποιούν μια αγορά ενός πακέτου μονάδων που μπορούν να χρησιμοποιηθούν για την αποστολή μηνυμάτων. Η αναλογία των μονάδων ανά μήνυμα είναι δέκα προς ένα, που σημαίνει ότι ο χρήστης πρέπει να έχει τουλάχιστον δέκα μονάδες στον λογαριασμό του για να στείλει ένα μήνυμα. Το κόστος για την αποστολή ενός Icebreaker είναι 2 μονάδες",

	"Trial pack": "Δοκιμαστικό πακέτο",
	"Only one trial pack per user allowed": "Επιτρέπεται μόνο ένα δοκιμαστικό πακέτο ανά χρήστη",
	"Used": "Μεταχειρισμένο",

	"Exclusive Promotion": "Αποκλειστική Προώθηση",
	"Account Deleted": "Ο λογαριασμός διαγράφηκε",
	"Log out Successful": "Αποσύνδεση Επιτυχής",

	"Do you like FREE LIVE SEX?": "Σας αρέσει το ΔΩΡΕΑΝ LIVE SEX;",
	"Enter this code to enjoy a 10% discount:": "Εισαγάγετε αυτόν τον κωδικό για να επωφεληθείτε έκπτωση 10%:",
	"Discount redeemable for your first online purchase. Expires in 2 hours.": "Έκπτωση εξαγοράσιμη για την πρώτη σας ηλεκτρονική αγορά. Λήγει σε 2 ώρες.",

	"This account has been deleted.": "Αυτός ο λογαριασμός έχει διαγραφεί.",
	"Our algorithm has found a better option in line with your taste.": "Ο αλγόριθμός μας βρήκε μια καλύτερη επιλογή σύμφωνα με τις προτιμήσεις σας.",
	"You will be redirected in a few seconds.": "Θα ανακατευθυνθείτε σε λίγα δευτερόλεπτα.",

	"Has added you to favorites": "Σας έχει προσθέσει στα αγαπημένα",
	"Is looking at your profile": "Κοιτάζει το προφίλ σας",
	"See profile": "Δείτε το προφίλ",
	"See message": "Δείτε το μήνυμα",

	"I think I am in love": "Νομίζω ότι είμαι ερωτευμένη",
	"Hey! I'm winking at you": "Γεια σου! Σου κλείνω το μάτι",
	"Tell me more about you. Fancy a chat?": "Πες μου περισσότερα για εσένα. Θέλεις να συνομιλήσουμε;",
	"Some flowers for you!": "Μερικά λουλούδια για σένα!",
	"Sending you a kiss": "Σου στέλνω ένα φιλί",
	"Surprise, it\'s me!": "Έκπληξη, εγώ είμαι!",
	"Hi, how are you?": "Γεια πως εισαι?",
	"Let's get naughty": "Ας γίνουμε άτακτοι",

	"Get 5 times the regular response rate. Premium members benefits:": "Λάβετε 5 φορές το κανονικό ποσοστό απόκρισης. Προνόμια μελών Premium:",
	"Appear high up on searches": "Εμφανίζονται ψηλά στις αναζητήσεις",
	"Distinctive badge that increases your visibility": "Διακριτικό σήμα που αυξάνει την ορατότητά σας",
	"5 Free Icebreakers a day": "5 δωρεάν icebreakers την ημέρα",
	"In addition to this, a voucher for a 15% Webcam discount": "Εκτός από αυτό, ένα κουπόνι έκπτωσης Webcam 15%",

	"The Icebreaker can only be used to start a conversation or in response to another icebreaker.": "Το Icebreaker μπορεί να χρησιμοποιηθεί μόνο για την έναρξη μιας συνομιλίας ή ως απάντηση σε άλλο icebreaker.",

	"Succesful purchase": "Επιτυχής αγορά",
	"Your purchase has been successful.": "Η αγορά σας ήταν επιτυχής.",
	"It can take a few minutes to update.": "Μπορεί να χρειαστούν μερικά λεπτά για την ενημέρωση.",
	"You will be redirected.": "Θα ανακατευθυνθείτε.",

	"Changes can take some minutes to update.": "Ενδέχεται να χρειαστούν μερικά λεπτά για να ενημερωθούν οι αλλαγές.",

	"Yearly Package": "Ετήσιο πακέτο",
	"Package": "Πακέτο",
	"Buy Now": "Αγόρασε τωρα",
	"The Elite status allows you to contact up to 5 different users every day by sending them unlimited messages.": "Η κατάσταση Elite σάς επιτρέπει να επικοινωνήσετε με έως και 5 διαφορετικούς χρήστες κάθε μέρα στέλνοντας απεριόριστα μηνύματα.",

	"Exclusive offer": "ΑΠΟΚΛΕΙΣΤΙΚΗ ΠΡΟΣΦΟΡΑ",
	"Welcome": "καλως ΗΡΘΑΤΕ",
	"Mary from {domain_name} support": "Μυρτώ από την υποστήριξη {domain_name}",
	"Welcome to {domain_name}. We hope you find what you are looking for.": "Καλώς ορίσατε στο {domain_name}. Ελπίζουμε να βρείτε αυτό που ψάχνετε.",
	"Here are some Pro Tips to be more successful and meet people:": "Ακολουθούν μερικές συμβουλές για να είστε πιο επιτυχημένοι και να συναντήσετε το ταίρι σας:",
	"Upload a profile picture to get more connections.": "Ανεβάστε μια εικόνα προφίλ για να λάβετε περισσότερες προτάσεις.",
	"Send an icebreaker to get a conversation easily started.": "Στείλτε ένα icebreaker για να ξεκινήσετε εύκολα και άμεσα μία συνομιλία..",
	"If you like someone don’t forget to add them to favorites so they will know.": "Αν σας αρέσει κάποιος μην παραλείψετε να τον προσθέσετε στα αγαπημένα για να το γνωρίζει. Και φυσικά, να στείλετε ένα μήνυμα και να ζητήσετε μία ημερομηνία!",
	"And of course, if you like somebody send a message and ask for a date!": "Και φυσικά, αν σας αρέσει κάποιος στείλτε ένα μήνυμα και ζητήστε μια ημερομηνία!",
	"If you need any extra help, please contact our ": "Εάν χρειάζεστε επιπλέον βοήθεια, επικοινωνήστε μαζί μας στην ",
	"support": "υποστήριξη",
	". We will be happy to help you.": ". Θα χαρούμε να σας βοηθήσουμε.",
	"Try your luck": "Δοκίμασε την τύχη σου!",
	"64% of our users have a date in the first 2 weeks.": "Το 64% των χρηστών μας έχει κλείσει ημερομηνία από τις πρώτες κι’ όλας 2 εβδομάδες!!",
	"Good Luck!.": "Καλή επιτυχία!",
	"*This message will be deleted upon closing.": "*Αυτό το μήνυμα θα διαγραφεί μόλις κλείσει.",

	"Private picture": "Ιδιωτικο",
	"Private pictures will appear blurred out. Only users that have already paid will be able to see them.": "Οι ιδιωτικές φωτογραφίες θα εμφανίζονται θολές. Μόνο οι χρήστες που έχουν ήδη πληρώσει θα μπορούν να τις δουν.",
	"Name change": "Αλλαγή ονόματος",
	"If you want to change your name or nickname, please contact our support team and we will do it within 24h.": "Εάν θέλετε να αλλάξετε το όνομά σας ή το ψευδώνυμό σας, επικοινωνήστε με την ομάδα υποστήριξης και θα το κάνουμε εντός 24 ωρών.",
	"See all images": "Δείτε όλες τις εικόνες",
	"Unlock all private photos forever for just 20 credits": "Ξεκλειδώστε όλες τις ιδιωτικές φωτογραφίες για πάντα με 20 μόλις μονάδες",
	"Unlock forever all private pictures": "Ξεκλειδώστε όλες τις ιδιωτικές φωτογραφίες για πάντα",

	"This email address is not registered, please sign up to log in.": "Αυτή η διεύθυνση email δεν είναι εγγεγραμμένη, εγγραφείτε για να συνδεθείτε.",
	"Congratulations, your account is now active.": "Συγχαρητήρια, ο λογαριασμός σας είναι πλέον ενεργός.",
	"Complete one last step and have fun!": "Ολοκληρώστε ένα τελευταίο βήμα και διασκεδάστε!",
	"OR": "Ή",

	"We sent you an email with a link to activate your account valid for the next 12 hours to:": "Σας στείλαμε ένα email με έναν σύνδεσμο για την ενεργοποίηση του λογαριασμού σας που ισχύει για τις επόμενες 12 ώρες στο:",
	"If you haven\'t received it in your inbox or ": "Εάν δεν το έχετε λάβει στα εισερχόμενά σας ή την ",
	"or you want to modify the email address, click on the button below.": "ή θέλετε να τροποποιήσετε τη διεύθυνση email, κάνετε κλικ στο παρακάτω κουμπί.",
	"We sent you an email to verify your account, the email will be valid for the next 12 hours:": "Σας στείλαμε ένα email για να επαληθεύσουμε τον λογαριασμό σας, το email θα ισχύει για τις επόμενες 12 ώρες:",
	"If you can\'t find it in your inbox or spam, you can edit or resend it": "Εάν δεν μπορείτε να το βρείτε στα εισερχόμενά σας ή στα ανεπιθύμητα μηνύματα, μπορείτε να το επεξεργαστείτε ή να το στείλετε ξανά",
	"Resend or change email": "Εκ νέου αποστολή ή αλλαγή email",
	"Please use the same email you registered.": "Χρησιμοποιήστε το ίδιο email που έχετε εγγραφεί.",
	"Connect with Google": "Συνδεθείτε μέσω Google",
	"Connect with Yahoo": "Συνδεθείτε μέσω Yahoo",
	"Connect with Microsoft": "Συνδεθείτε μέσω Hotmail",
	"Or turn back": "Πηγαίνετε πίσω",
	"Complete your registration": "Ολοκληρώστε την εγγραφή σας",

	"It will not be shared": "Δεν θα κοινοποιηθεί",
	"It will never be shared. 100% Privacy": "Δεν θα κοινοποιηθεί ποτέ. 100% Απόρρητο",

	"Unlock all private pictures forever.": "Ξεκλειδώστε όλες τις ιδιωτικές φωτογραφίες για πάντα.",
	"Unlock": "Ξεκλείδωμα",

	"You will be redirected in a second": "Θα ανακατευθυνθείτε σε ένα δευτερόλεπτο",

	"Card payment": "Πληρωμή με κάρτα",
	"Bank transfer": "τραπεζική μεταφορά",
	"Prepaid card": "Προπληρωμένη κάρτα",
	"SofortBanking": "SofortBanking",

	"Error": "Λάθος",
	"page not found": "Η σελίδα δεν βρέθηκε",
	"Back to homepage": "Αρχικη σελιδα",

	"per month": "κάθε μήνα",
	"week": "εβδομάδα",
	"{count} week": "{count} εβδομάδα",

	"Your profile has been blocked": "Το προφίλ σας έχει αποκλειστεί",
	"In order to offer the best possible user experience, we block all profiles that haven\'t sent a message within 21 days of registration.": "Προκειμένου να προσφέρουμε την καλύτερη δυνατή εμπειρία χρήστη, αποκλείουμε όλα τα προφίλ που δεν έχουν στείλει μήνυμα εντός 21 ημερών από την εγγραφή.",
	"Please acquire a credit package to unlock your profile and restore all its features.": "Αποκτήστε ένα πακέτο μονάδων για να ξεκλειδώσετε το προφίλ σας και να επαναφέρετε όλες τις λειτουργίες του.",
	"Restore access to:": "Επαναφορά πρόσβασης σε:",
	"All messages": "Όλα τα μηνύματα",
	"Users search": "Αναζήτηση χρήστη",
	"Your contacts": "Οι επαφές σας",
	"All favourites": "Όλα τα αγαπημένα",
	"All pictures": "Όλες οι εικόνες",
	"Send Icebreakers": "Στείλτε icebreakers",
	"Unblock Profile": "Κατάργηση αποκλεισμού προφίλ",

	"This website uses its own and third-party cookies and identifiers to improve accessibility and analyse our traffic. If you continue browsing, we consider that you accept its use. For more information visit our": "Αυτός ο ιστότοπος χρησιμοποιεί δικά του και τρίτων cookies και αναγνωριστικά για τη βελτίωση της προσβασιμότητας και την ανάλυση της επισκεψιμότητάς μας. Εάν συνεχίσετε την περιήγηση, θεωρούμε ότι αποδέχεστε τη χρήση του. Για περισσότερες πληροφορίες επισκεφθείτε μας",
	"Cookies Policy": "Πολιτική cookies",

	"DATE GUARANTEE": "ΕΓΓΥΗΜΈΝΗ ΗΜΕΡΟΜΗΝΊΑ",
	"Take advantage of our Date guarantee": "Εγγυόμαστε ημερομηνία. Επωφεληθείτε",
	"No date? Money Back!": "Δεν βγαίνεις ραντεβού; Επιστροφή χρημάτων!",
	"No risk": "Χωρίς ρίσκο",
	"Guarantee of success": "Εγγύηση επιτυχίας",
	"Terms and Conditions": "Οροι και Προϋποθέσεις",

	"Boost your visibility": "Ενισχύστε την ορατότητά σας",
	"SAVE": "ΕΞΟΙΚΟΝΟΜΕΙΤΕ",
	"Add 3 months premium": "Προσθέστε 3 μήνες premium",
	"Add {months} months premium": "Προσθήκη {months} μηνών premium",

	"We guarantee you a real date.": "Σας εγγυόμαστε μια πραγματική ημερομηνία.",
	"YES, I WANT A DATE": "ΝΑΙ, ΘΕΛΩ ΡΑΝΤΕΒΟΥ",

	"Terms and conditions of the date guarantee. In order to fulfill all refund conditions, you must have a fully completed profile for a period of at least six months and your personal description in your profile. Your profile must contain at least one approved picture throughout this period. Furthermore, each week, you must contact at least seven different members located close to you (radius of 100km) within your age range (-5/+5 years). If you fulfill all the conditions listed above and you still were not able to find a date, we will full refund all the payments you made during this time. This guarantee is only valid for the first 12 months following your registration. Good luck!": "Όροι και προϋποθέσεις της εγγύησης ημερομηνίας. Για να εκπληρώσετε όλες τις προϋποθέσεις επιστροφής χρημάτων, πρέπει να έχετε ένα πλήρως ολοκληρωμένο προφίλ διάρκειας τουλάχιστον έξι μηνών και την προσωπική σας περιγραφή στο προφίλ σας. Το προφίλ σας πρέπει να περιέχει τουλάχιστον μία εγκεκριμένη εικόνα καθ' όλη τη διάρκεια αυτής της περιόδου. Επιπλέον, κάθε εβδομάδα, πρέπει να επικοινωνείτε με τουλάχιστον επτά διαφορετικά μέλη που βρίσκονται κοντά σας (ακτίνα 100 χλμ.) εντός του ηλικιακού εύρους σας (-5/+5 ετών). Εάν πληροίτε όλες τις προϋποθέσεις που αναφέρονται παραπάνω και εξακολουθείτε να μην μπορείτε να βρείτε ημερομηνία, θα επιστρέψουμε πλήρως όλες τις πληρωμές που κάνατε κατά τη διάρκεια αυτής της περιόδου. Αυτή η εγγύηση ισχύει μόνο για τους πρώτους 12 μήνες μετά την εγγραφή σας. Καλή τύχη!",

	"You have {count} days premium left": "Σας απομένουν {count} ημέρες premium",
	"Credit Packages do not auto-renew.": "Τα πακέτα μονάδων δεν ανανεώνονται αυτόματα.",
	"Premium packages are auto-renewable, which means they will auto-renew when they expire.": "Τα πακέτα Premium είναι αυτόματα ανανεώσιμα, πράγμα που σημαίνει ότι θα ανανεωθούν αυτόματα όταν λήξουν.",
	"Check our special offer before deleting your account!": "Ελέγξτε την ειδική προσφορά μας πριν διαγράψετε τον λογαριασμό σας!",
	"Delete my account": "διαγραφη",
	"Free": "Ελεύθερος",

	"Premium, Elite and VIP packages are auto-renewable, which means they will auto-renew when they expire.": "Τα πακέτα Premium, Elite και VIP ανανεώνονται αυτόματα, πράγμα που σημαίνει ότι δεν χρειάζεται να κάνετε κάτι εσείς όταν λήξουν.",
	"and can confirm that I am 18 years or older.": "και μπορώ να επιβεβαιώσω ότι είμαι 18 ετών και άνω.",

	"COMPLETE YOUR PURCHASE": "ΟΛΟΚΛΗΡΩΣΤΕ ΤΗΝ ΑΓΟΡΑ ΣΑΣ",
	"Payment details": "Οι λεπτομέρειες πληρωμής",
	"Total": "Σύνολο",
	"3-digit number on the back of your credit card": "3ψήφιος αριθμός στο πίσω μέρος της πιστωτικής σας κάρτας",
	"MM / YY": "ΜΜ/ΕΕ",
	"MM": "ΜΜ",
	"YY": "YY",
	"Name on card": "όνομα στην κάρτα",
	"Charges will appear discreetly as tpmpsup.com": "Οι χρεώσεις θα εμφανίζονται διακριτικά ως tpmpsup.com",
	"Buy Now": "Αγόρασε τωρα",
	"Premium package 3 Months": "Premium πακέτο 3 μηνών",

	"This purchase was declined. Please check your details and try again.": "Αυτή η αγορά απορρίφθηκε. Παρακαλούμε ελέγξτε τα στοιχεία σας και δοκιμάστε ξανά.",
	"Your purchase was succesful.": "Η αγορά σας ήταν επιτυχής.",

	"SPECIAL OFFER": "ΕΙΔΙΚΗ ΠΡΟΣΦΟΡΑ",
	"Unlock your account with our special offer": "Ξεκλειδώστε τον λογαριασμό σας με την ειδική προσφορά μας",
	"Take advantage of our special offer to unlock your profile and restore all its features.": "Επωφεληθείτε από την ειδική προσφορά μας για να ξεκλειδώσετε το προφίλ σας και να επαναφέρετε όλες τις λειτουργίες του.",

	"card_number_require": "Απαιτείται αριθμός κάρτας",
	"card_number_invalid": "Ο αριθμός κάρτας δεν είναι έγκυρος",
	"card_name_require": "Απαιτείται όνομα κατόχου κάρτας",
	"card_name_invalid": "Το όνομα κατόχου κάρτας δεν είναι έγκυρο",
	"card_cvc_require": "Απαιτείται CVC",
	"card_cvc_invalid": "Μη έγκυρο CVC",
	"card_expiry_require": "Απαιτείται ημερομηνία λήξης της κάρτας",
	"card_expiry_invalid": "Η ημερομηνία λήξης της κάρτας είναι άκυρη",

	"Private photo": "Ιδιωτική φωτογραφία",
	"Search for someone now": "Ψάξε για κάποιον τώρα",
	"Edit": "Επεξεργασία",

	"Locked Album": "Κλειδωμένο άλμπουμ",
	"Get credits to unlock all albums": "Λάβετε μονάδες για να ξεκλειδώσετε όλα τα άλμπουμ",
	"picture ::: pictures": "εικόνα ::: εικόνες",
	"Open": "Άνοιξε",

	"Receive notifications": "Λήψη ειδοποιήσεων",
	"I want to be notified when I receive a message": "Θέλω να ειδοποιούμαι όταν λαμβάνω ένα μήνυμα",
	"No": "Οχι",
	"Yes": "Ναί",

	"logout_confirm_title": "Αποσύνδεση",
	"Are you sure you want to log out?": "Είσαι σίγουρος ότι θέλεις ν' αποσυνδεθείς;",

	"Your payment has been cancelled": "H πληρωμή σου ακυρώθηκε",
	"Something went wrong, please try again in 10 minutes": "Κάτι πήγε στραβά! Παρακαλώ προσπάθησε πάλι σε 10 λεπτά",

	"Please accept the terms and conditions to continue": "Αποδεχτείτε τους όρους και τις προϋποθέσεις για να συνεχίσετε",
	"By checking this box and clicking continue I accept the": "Επιλέγοντας αυτό το πλαίσιο και κάνοντας κλικ στη συνέχεια, αποδέχομαι το",
	"rg_terms": "Οροι και Προϋποθέσεις",
	"rg_privacy": "Ιδιωτικότητα",
	"rg_cookies": "Cookies",
	"I am aware of the use of fictitious profiles on the website and I confirm that I am of legal age.": "Γνωρίζω τη χρήση εικονικών προφίλ στον ιστότοπο και επιβεβαιώνω ότι είμαι σε νόμιμη ηλικία.",

	"Cookie": "Cookie",
	"Responsible Party": "Μέρος υπεύθυνο",
	"Category": "Κατηγορία",
	"Cookie Name": "Όνομα",
	"Purpose": "Σκοπός",
	"Lifespan": "Διάρκεια",
	"Type of Cookie": "Τύπος Cookie",
	"Strictly necessary": "Αυστηρά απαραίτητο",
	"Functional": "Λειτουργικό",
	"Performance": "Επίδοση",
	"Advertising": "διαφήμιση",
	"cookie-policy": "cookie-policy",
	"cookie policy": "Πολιτική Cookies",

	"We Care About Your Privacy": "Ενδιαφερόμαστε για το απόρρητό σας",
	"This site uses its own, technical and third party cookies to improve navigation performance, analyzing visitors behaviour to help us and our marketing partners measure campaign results and personalized advertising. By clicking \"Accept All\" you are agreeing to all of these cookies.": "Αυτός ο ιστότοπος χρησιμοποιεί δικά του, τεχνικά cookie και cookie τρίτων για τη βελτίωση της απόδοσης πλοήγησης, αναλύοντας τη συμπεριφορά των επισκεπτών για να βοηθήσουμε εμάς και τους συνεργάτες μας στο μάρκετινγκ να μετρήσουμε τα αποτελέσματα της καμπάνιας και την εξατομικευμένη διαφήμιση. Κάνοντας κλικ στο \"Αποδοχή όλων\" συμφωνείτε με όλα αυτά τα cookies.",
	"Accept All": "Αποδοχή όλων",
	"Cookies Settings": "Ρυθμίσεις cookies",
	"About your privacy": "Σχετικά με το απόρρητό σας",
	"We use cookies for traffic balancing, session identification, analytics and marketing attribution. You can opt-in or opt-out of any or all of them from this panel." : "Χρησιμοποιούμε cookies για την εξισορρόπηση επισκεψιμότητας, την αναγνώριση περιόδου σύνδεσης, τ’ αναλυτικά στοιχεία της απόδοσης μάρκετινγκ. Μπορείτε να ενεργοποιήσετε ή να εξαιρεθείτε απ’ οποιοδήποτε ή και απ’ όλα στο συγκεκριμένο αυτό πλαίσιο.",
	"You will be able to change your set up at any time from our :cookies_policy page": "Θα μπορείτε να αλλάξετε τη ρύθμισή σας ανά πάσα στιγμή από τη σελίδα μας :cookies_policy",
	"Accept all": "Αποδοχή όλων",
	"Manage Consent Preferences": "Διαχείριση Προτιμήσεων συναίνεσης",
	"Technical (Mandatory)": "Τεχνικό (Υποχρεωτικό)",
	"Performance (Monitor website performance)": "Απόδοση (παρακολούθηση απόδοσης ιστότοπου)",
	"Functional (User experience improvement)": "Λειτουργικό (Βελτίωση εμπειρίας χρήστη)",
	"Advertising (Marketing measurement)": "Διαφήμιση (Μέτρηση μάρκετινγκ)",
	"Save Selection": "Αποθήκευση επιλογής",
	"Reject All": "Απόρριψη όλων",

	"We and our partners process data to provide:": "Εμείς και οι συνεργάτες μας επεξεργαζόμαστε δεδομένα για την παροχή:",
	"Use precise geolocation data. Actively scan device characteristics for identification. Store and/or access information on a device. Personalised ads and content, ad and content measurement, audience insights and product development.": "Χρησιμοποιήστε ακριβή δεδομένα γεωγραφικής τοποθεσίας. Σαρώστε ενεργά τα χαρακτηριστικά της συσκευής για ταυτοποίηση. Αποθηκεύστε ή/και αποκτήστε πρόσβαση σε πληροφορίες σε μια συσκευή. Εξατομικευμένες διαφημίσεις και περιεχόμενο, μέτρηση διαφημίσεων και περιεχομένου, πληροφορίες κοινού και ανάπτυξη προϊόντων.",
	"List of partners": "Λίστα συνεργατών",
	"Cookie Policy": "Πολιτική Cookies",
	"These cookies are used in connection with the tracking of actions related to advertisements. For example, these cookies will remember that you have visited {name} and can be used to show you a personalized advertisement on another website. Please check the following links of the platforms where we promote ourselves, Google, Microsoft and Twitter. for more information.": "Αυτά τα cookies χρησιμοποιούνται σε σχέση με την παρακολούθηση ενεργειών που σχετίζονται με διαφημίσεις. Για παράδειγμα, αυτά τα cookie θα θυμούνται ότι έχετε επισκεφτεί το {name} και μπορούν να χρησιμοποιηθούν για να σας εμφανίσουν μια εξατομικευμένη διαφήμιση σε άλλο ιστότοπο. Ελέγξτε τους παρακάτω συνδέσμους των πλατφορμών προώθησήσης μας, Google, Microsoft και Twitter. Για περισσότερες πληροφορίες.",
	"Delete cookies": "Διαγραφή cookies",
	"Save selection": "Αποθήκευση επιλογής",
	"Reject all": "Απόρριψη όλων",

	"{name} hasn't replied to you yet. Send another message!": "Ο χρήστης {name} δεν σας έχει απαντήσει ακόμα. Στείλτε ένα άλλο μήνυμα!",
	"Validate my Ice-breaker": "Επικυρώστε το Ice-breaker μου",

	"Distance": "Απόσταση",
	"now": "τώρα",

	"Dear User,": "Αγαπητέ Χρήστη,",
	"Thanks for your interest in joining our website, but, in order to keep a gender balance close to 50/50 men and women, registration is not allowed for men, at the moment.": "Ευχαριστούμε για το ενδιαφέρον σου να εγγραφείς στον ιστότοπό μας, αλλά, προκειμένου να διατηρηθεί μια ισορροπία φύλου κοντά στο 50/50 μεταξύ ανδρών και γυναικών, δεν επιτρέπεται η εγγραφή για άνδρες, προς το παρόν.",
	"If you still want a date, click on the button below and try one of the best websites online.": "Εάν εξακολουθείς ν΄ αναζητάς μια ημερομηνία, κάνε κλικ στο κουμπί λίγο παρακάτω και κάνε την δοκιμή σου σ' έναν απ' τους καλύτερους ιστότοπους στο διαδίκτυο.",
	"Try Now": "Προσπάθησε τώρα",

	"Your account has been deleted.": "Ο λογαριασμός σας έχει διαγραφεί.",
	"According to your choices, our algorithms have found a better option for you.": "Σύμφωνα με τις επιλογές σου, οι αλγόριθμοί μας βρήκαν μια καλύτερη επιλογή για 'σένα.",
	"See More": "Δες περισσότερα",

	"10 credits for you!": "10 μονάδες για 'σένα!",
	"Get 3 free Icebreakers": "Απόκτησε 3 δωρεάν icebreakers",
	"Free Icebreakers": "Δωρεάν παγοθραυστικά",
	"Congratulations, you have received 3 Icebreakers!": "Συγχαρητήρια, μόλις έλαβες 3 παγοθραυστικά!",

	"Apple pay only works with the Safari browser. Please open your Safari browser and login to your account in order to proceed with this payment.": "Το Apple pay λειτουργεί μόνο με το πρόγραμμα περιήγησης Safari. Άνοιξε το πρόγραμμα περιήγησής σου στο Safari και συνδέσου στον λογαριασμό σου για να προχωρήσεις σ' αυτή την πληρωμή.",

	"No nudity": "Χωρίς γυμνό",
	"Nudity allowed": "Επιτρέπεται το γυμνό",

	"Edit profile": "Επεξεργασια προφιλ",
	"Online": "Σε σύνδεση",
	"Step": "Βήμα",
	"Completed": "Ολοκληρώθηκε το",
	"Help": "Βοήθεια",
	"or Drag and drop": "ή σύρε και άφησε",

	"You will be able to send messages in": "Θα μπορείς να στέλνεις μηνύματα σε",
	"Send": "Στείλε",
	"Success": "Επιτυχία",
	"Start a conversation with {name}": "Ξεκίνησε μια συνομιλία με {name}",
	"Failed": "Απέτυχε",
	"Congratulations, your account has been successfully created.": "Συγχαρητήρια, ο λογαριασμός σου δημιουργήθηκε με επιτυχία.",
	"Contact our support": "Επικοινωνήστε με την υποστήριξή μας",

	"About": "Σχετικά με",
	"Scale": "Κλίμακα",
	"Rotate": "Γυρίζω",

	"No favorites added": "Δεν προστέθηκαν αγαπημένα",

	"Enter Email": "Εισάγετε το Email",

    "We have sent you an email to:": "Σας έχουμε στείλει ένα email στο",
    "Please confirm by clicking the \"delete account\"  button in that email and your account will be permanently deleted from our system.": "Παρακαλούμε επιβεβαιώστε κάνοντας κλικ στο σημείο «Διαγραφή λογαριασμού» στο email και ο λογαριασμός σας θα διαγραφεί οριστικά από το σύστημά μας",
    "DELETE ACCOUNT": "Διαγραφή λογαριασμού",

	"Didn\'t find what you were looking for?": "Δεν μπορείτε να βρείτε αυτό που ψάχνετε;",
	"Please send us an email and we will get back to you.": "Στείλτε μας ένα email και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.",
	"Or contact us using the form": "Ή επικοινωνήστε μαζί μας χρησιμοποιώντας την παρακάτω φόρμα.",

	"BOOST YOUR ACCOUNT": "ΒΕΛΤΙΩΣΤΕ ΤΟ ΛΟΓΑΡΙΑΣΜΟ ΣΑΣ",
	"We will send you an email to boost your account:": "Θα σας στείλουμε ένα e-mail για τη βελτιστοποίηση του λογαριασμού σας:",
	"Get Free exclusive benefits": "Αποκτήστε δωρεάν αποκλειστικές παροχές",
	"Premium Status 24h": "Κατάσταση Premium 24h",
	"5 Free Credits": "5 επιπλέον μονάδες",
	"3 Free Icebreakers": "3 Δωρεάν icebreakers",
	"IMPROVE ACCOUNT": "ΒΕΛΤΙΣΤΟΠΟΙΗΣΗ ΤΟΥ ΛΟΓΑΡΙΑΣΜΟΥ",

	"COMPLETE REGISTRATION": "ΟΛΟΚΛΗΡΩΣΗ ΤΗΣ ΕΓΓΡΑΦΗΣ",
	"Confirm your email and complete registration": "Επιβεβαιώστε το email σας και ολοκληρώστε την εγγραφή",
	"Benefits": "Οφέλη",
	"More Visibility": "Περισσότερη ορατότητα",
	"Send Messages": "Αποστολή μηνυμάτων",

    "Your registration is completed": "Η εγγραφή σας έχει ολοκληρωθεί",

    "Disclaimer": "Αποποίηση ευθυνών",
    "Physical contact may not be possible in all situations. The primary goal of {name} is entertainment, not facilitating in-person meetings or dating. {name} uses fictitious profiles, marked with a heart icon, which are intended solely for messaging and entertainment purposes.": 'Η φυσική επαφή δεν είναι πάντα εφικτή. Ο κύριος σκοπός του {name} είναι η ψυχαγωγία και όχι η διευκόλυνση συναντήσεων ή ραντεβού στον πραγματικό κόσμο. Το {name} χρησιμοποιεί φανταστικά προφίλ, επισημασμένα με ένα εικονίδιο καρδιάς, του οποίου ο μοναδικός σκοπός είναι η ψυχαγωγία μέσω μηνυμάτων.',
    "By using this website and its entertainment services, you acknowledge and agree that payments may be processed by a separate entity within our group of companies. This entity operates solely for payment processing purposes and may differ from the operating company providing the entertainment services.": 'Χρησιμοποιώντας αυτή την ιστοσελίδα και τις υπηρεσίες ψυχαγωγίας της, αναγνωρίζετε και συμφωνείτε ότι οι πληρωμές ενδέχεται να επεξεργάζονται από μια ξεχωριστή οντότητα εντός του ομίλου εταιρειών μας. Αυτή η οντότητα λειτουργεί αποκλειστικά για σκοπούς επεξεργασίας πληρωμών και μπορεί να διαφέρει από την εταιρεία που παρέχει τις υπηρεσίες ψυχαγωγίας.',

    "Free daily icebreaker": "Δωρεάν καθημερινά icebreaker",
	"We will send you an email to:": "Θα σας αποσταλεί ηλεκτρονικό μήνυμα στο Email:",
	"Open it and get your free Icebreaker.": "Ανοίξτε το για να λάβετε το δωρεάν icebreaker.",
	"Get Icebreaker": "Λάβετε icebreaker",
	"Congratulations, you received a free Icebreaker.": "Συγχαρητήρια, μόλις λάβατε ένα δωρεάν icebreaker.",

    "Your account has been updated": "Ο λογαριασμός σας ενημερώθηκε",
    "Are you sure you want to unsubscribe from all email notifications?": "Είστε βέβαιοι ότι θέλετε να απεγγραφείτε από όλες τις ειδοποιήσεις email;"
}
